import type { ReactNode } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@pfida-finance/ui/components';
import { formatCurrency } from '../utils/formatSavingsPoints';

type Props = {
  children: ReactNode;
  propertyValue: string;
  depositPercentage: string;
  targetAmount: string;
};

export function DownPaymentTooltip({ children, propertyValue, depositPercentage, targetAmount }: Props) {
  const depositPct = parseFloat(depositPercentage);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="cursor-help border-b border-dashed border-current inline">
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="font-mono text-xs leading-relaxed text-left">
          <p>Property Value:  {formatCurrency(propertyValue)}</p>
          <p>Your Deposit:  {depositPct.toFixed(0)}%</p>
          <p className="mt-2">
            Property Value × max(Deposit%, 20%) ÷ 100 = {formatCurrency(targetAmount)}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
